var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bgImg d-flex align-items-sm-center justify-content-center justify-content-sm-start",staticStyle:{"white-space":"pre"}},[_c('div',{staticClass:"textStyle pt-5"},[_vm._v(_vm._s(_vm.showHBDName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }